import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import ClickLink from './ClickLink'
import Unsubscribe from './Unsubscribe'
import ReportAbuse from './ReportAbuse'

import { addHistoryClick } from '../redux/emailsActions'

const APIEmailComponents = ({ match, addHistoryClick }) => {
  return (
    <>
      <Switch>
        <Route
          path={`${match.url}/click-link/:token`}
          render={(props) => <ClickLink {...props} addHistoryClick={addHistoryClick} />}
        />
        <Route
          path={`${match.url}/unsubscribe/:token`}
          render={(props) => <Unsubscribe {...props} addHistoryClick={addHistoryClick} />}
        />
        <Route
          path={`${match.url}/report-abuse/:token`}
          render={(props) => <ReportAbuse {...props} addHistoryClick={addHistoryClick} />}
        />
      </Switch>
    </>
  )
}

export default connect(null, { addHistoryClick })(APIEmailComponents)
